export default [

     {
          path: '/degree',
          name: 'Degree',
          component: () => import("@/views/Page/Degree/Degree.vue"),
           meta: {
               title: '#Default# | Degree',
          },
     }
];